module.exports = __webpack_public_path__ + "img/der_01_robot_head.ec3037c0.png";